import React, {useState,useEffect} from 'react'
import styled from 'styled-components';
import {get,groupBy,keyBy,mapValues,merge,range,fill} from 'lodash-es';
import { withData } from '../../Data';
import useFetchData from '../../crud/useFetchData';
import {proto,url} from '../../Helpers/api';
import Tabela, {TabelaLinha as TL} from '../../Common/Tabela';
import CelulaHeader from '../../Common/CelulaHeader';
import Celula from '../../Common/Celula';
import MyDialog from '../MoreInfo/MyDialog';
import MIAdmissoes from '../MoreInfo/Admissoes';
import MIRescisoes from '../MoreInfo/Rescisoes';
import MIFerias from '../MoreInfo/Ferias';
import MIAfast from '../MoreInfo/Afast';
import MIEmprFolha from '../MoreInfo/EmprFolha';
import Seletor from '../../App/Seletor';
import GrupoGraph from './GrupoGraph';
import LineChart from '../Graficos/LineChart';
import {hoje,mesesExtenso3} from '../../Helpers/date';
import SeletorAno from '../../Common/SeletorAno';
import { formataMoeda } from '../../Helpers/money';

const TabelaLinha = styled(TL)`
  grid-template-columns: 180px repeat(12,70px);
`

// const formataMoeda = v => v.toLocaleString("pt-BR", { style: "currency", currency:"BRL" } )

const metricas = {
  1: {
    Dialog: MyDialog(MIAdmissoes),
    key: "qtdeAdmissoes",
    label: "Admissões"
  },
  2: {
    Dialog: MyDialog(MIRescisoes),
    key: "qtdeRescisoes",
    label: "Rescisões"
  },
  3: {
    Dialog: MyDialog(MIFerias),
    key: "qtdeFerias",
    label: "Férias"
  },
  4: {
    Dialog: MyDialog(MIAfast),
    key: "qtdeAfastamentos",
    label: "Afastamentos"
  },
  5: {
    modif: formataMoeda,
    key: "folhaLiquido",
    label: "Valor Líquido da Folha"
  },
  6: {
    Dialog: MyDialog(MIEmprFolha),
    key: "qtdeEmprFolha",
    label: "Quantidade de Empregados em Folha"
  },
  7: {
    modif: formataMoeda,
    key: "rescLiquido",
    label: "Valor Líquido de Rescisões"
  },
  8: {
    modif: formataMoeda,
    key: "feriasLiquido",
    label: "Valor Líquido de Férias"
  },
}

function FetchMetrica(metricaId, empresaId) {
  return useFetchData(`${proto}://${url}/main/metricas/pessoal/${empresaId}/${metricaId}`);
}

const prepare = data => (
  mapValues(groupBy(data, "ano"), d => (
    mapValues(keyBy(d, "mes"),({ano,mes,...o})=>o)
  ))
)

function EmbedDialog(condition,DialogComponent) {
  let Outer = condition ? DialogComponent : React.Fragment;
  return Component => props => (
    <Outer>
      <Component {...props} />
    </Outer>
  )
}

const EachEmpresa = props => EmbedDialog(
  props.metricaId && metricas[props.metricaId].Dialog, metricas[props.metricaId].Dialog
)(EachEmpresa_)(props)

function simplify (props,data) {
  const {metricaId,empr,ano} = props;
  const {Codigo} = empr;
  let out = range(1,13).map(mes => get(data, [ano,mes,metricas[metricaId].key], 0))
  return s => ({
    ...s,
    [Codigo]: out
  })
}

function Totais (props) {
  const {metrica,metricaId,data,c,empresasById,ano,grupo,fullLoaded} = props;
  if (!fullLoaded) {
    return (
      <TabelaLinha boldFirst>
        <Celula>Carregando...</Celula>
      </TabelaLinha>
    )
  }
  const totais_init = fill(Array(12),0)
  const totais = metricaId && (
    Object.entries(data)
      .map(([k,v])=> v)
      .reduce((ac,cur)=> range(12).map(i => ac[i]+cur[i]), totais_init)
  ) || totais_init
  let modif = metricas[metricaId].modif || (a=>a);
  return (
    <TabelaLinha>
      <Celula>Totais</Celula>
      {totais.map((total,i) => {
        let onC = c && total && (total !== "0")
        return (
          <Celula
            align="flex-end"
            key={"bTot"+i}
            onClick={onC ? (()=>c.set({
              fdata: data, metrica, empresasById, grupo, ano, mes:i, total, modif
            })) : undefined}
          >
          {modif(total)}
          </Celula>
      )})}
    </TabelaLinha>
  )
}

function EachEmpresa_(props) {
  const {metricaId,empr,ano,c,setData} = props;
  const {isLoading,isFinished,data=[]} = FetchMetrica(metricaId,empr.Codigo)
  let dt = (isFinished) ? prepare(data) : null
  const { Codigo } = empr;
  useEffect(() => {
    if (dt) setData(simplify(props,dt))
  }, [data,isFinished,ano,metricaId])
  let modif = metricas[metricaId].modif || (a=>a);
  return (
    <TabelaLinha boldFirst>
    {isLoading && <Celula>Carregando...</Celula>}
    {isFinished && dt && (
      <>
      <Celula>{`${Codigo} (${empr.Apelido})`}</Celula>
      {range(1,13).map(mes => {
        let value = get(dt, [ano,mes,metricas[metricaId].key], "-")
        let onC = c && value && (value !== "-")
        return (
          <Celula
            align="flex-end"
            key={"b"+mes}
            onClick={onC ? (()=>c.set({ano,mes,empresa:Codigo})) : undefined}
          >
          {modif(value)}
          </Celula>
        )
      })}
      </>
    )}
    </TabelaLinha>
  )
}

function ShowMetrica(props) {
  const {empresasById,grupo} = props;
  return (
    <Tabela>
      <TabelaLinha header>
        <CelulaHeader field={['empr','Empresa']} />
        {[ "Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez" ].map((mes,i) => (
          <CelulaHeader key={"a"+i} field={[mes,mes]} align="flex-end" />
        ))}
      </TabelaLinha>
      {grupo.Membros.map(id => {
        let empr = empresasById[id]
        return (
          <EachEmpresa empr={empr} {...props} />
        )
      })}
      {EmbedDialog(true, MyDialog(GrupoGraph))(Totais)(props)}
    </Tabela>
  )
}

function GrupoViz(props) {
  const { grupo, data } = props;
  const { empresasById } = data;
  if (!grupo) return null;
  const {ano:ano_, mes:mes_} = hoje();
  let [ ano, setAno ] = useState(ano_);
  let [ met, setMet ] = useState(mes_ - 1);
  let [ fdata, setData ] = useState({});
  const [ opt, setOpt ] = useState([]);
  useEffect(() => {
    setOpt(Object.entries(metricas).map(([value,{label}]) => ({label,value})))
  }, [])
  useEffect(() => {
    if (!met) setData({})
  }, [met])
  let lineData = [], lineKeys = []
  let fullLoaded = grupo.Membros.length === Object.keys(fdata).length;
  if (fullLoaded) {
    lineData = range(12).map(mes => {
      let a = {};
      a.mes = mesesExtenso3[mes]
      if (ano === ano_ && (mes_-1) <= mes) return a;
      Object.entries(fdata).forEach(([Codigo,dt]) => { a[Codigo] = dt[mes] });
      return a;
    }).filter(i=>i)
    lineKeys = Object.keys(fdata);
  }
  return (
    <div style={{
      padding: "10px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }}>
      <div style={{
        display: "grid",
        gridTemplateColumns: "440px 150px",
        gridGap: "25px",
        marginBottom: "10px"
      }}>
        <Seletor
          fullWidth
          label={"Métrica"}
          onChange={setMet}
          value={met}
          placeholder="Selecione a métrica"
          suggestions={opt}
        />
        <SeletorAno
          value={ano}
          onChange={setAno}
          // minValue={2015}
          label="Ano"
        />
      </div>
      {met && met.value && (
        <ShowMetrica 
          metrica={met.value && metricas[met.value]}
          metricaId={met.value}
          empresasById={empresasById}
          grupo={grupo}
          ano={ano}
          setData={setData}
          data={fdata}
          fullLoaded={fullLoaded}
        />
      )}
      {fullLoaded && 
        <LineChart 
          xName="mes"
          data={lineData}
          keys={lineKeys}
          empresasById={empresasById}
        />
      }
      {/* 
      se quiser exibir várias métricas:
      {[1,2,3,4].map(i => (
        <ShowMetrica 
          metricaId={i}
          empresasById={empresasById}
          grupo={grupo}
          ano={ano}
        />
      ))} 
      */}
    </div>
  )
}

export default withData(GrupoViz);
